import store from '@/store/index'

class CategoryModule {
  categories = {
    get() {
      return store.state.categories
    },
    set(habits) {
      store.commit('SET_CATEGORIES', habits)
    }
  }

  selectedCategory = {
    get() {
      return store.state.selectedCategory
    },
    set(category) {
      store.commit('SET_SELECTED_CATEGORY', category)
    }
  }
}

export default new CategoryModule()
